<div fxLayout="row wrap" fxLayoutAlign="space-between" class="fullwidth">
    <div fxLayout="row" fxLayoutAlign="start" fxLayoutGap="10px" class="mb-20">
        <button type="button" *ngIf="actionRole.can_create" mat-raised-button
            (click)="onOpenCreateDialog()" color="primary">
            {{ 'button_name.add_new' | translate: {section_name: sectionName} }}
        </button>
        <button type="button" *ngIf="actionRole.can_delete" mat-stroked-button
            (click)="onDeleteSelected()" color="warn" [disabled]="!hasSelectedValues">
            {{ 'button_name.delete_selected' | translate }}
        </button>
        <button *ngIf="actionRole.can_export_excel" type="button" mat-stroked-button [matMenuTriggerFor]="action">
            {{ 'button_name.export' | translate }}
            <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu #action="matMenu">
            <button mat-menu-item (click)="onExportAll()">{{ 'button_name.export_all' | translate }}</button>
            <button mat-menu-item (click)="onExportSelected()">{{ 'button_name.export_selected' | translate }}</button>
        </mat-menu>
    </div>

    <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="10px" class="mb-20">
        <button (click)="onResetForm()" mat-raised-button color="primary" type="button">
            <mat-icon matPrefix>autorenew</mat-icon> {{ 'button_name.reset' | translate }}
        </button>
        <button (click)="onStartSearch()" mat-raised-button color="primary" type="button">
            <mat-icon matPrefix>search</mat-icon> {{ 'button_name.search' | translate }}
        </button>
    </div>
</div>
